import ConvertTranscript from "@/features/dashboard/pages/convert-transcript/components";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/dashboard/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ConvertTranscript />;
}
